import React, { Component } from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import { toJS } from "mobx";
import { observer, inject } from "mobx-react";
import FilterContainer from "./FilterContainer";
import { GridContainer, GridRow, GridColumn } from "arv-reactcomponents";
import { isDesktop } from "../../../utils";

@inject("ProductStore")
@observer
class StickyFilterBlock extends Component {
  render() {
    const filters =
      this.props.ProductStore &&
      this.props.ProductStore.ProductData &&
      this.props.ProductStore.ProductData.filters;
    if (!filters) return null;
    const { filterBy } = toJS(filters);
    const RenderComponent = (
      <GridContainer className="nw-stickyfilters-container">
        <GridRow>
          <GridColumn className="nwc-grid-col-xs nw-desktop-only nw-stickyfilters-col">
            <form name="stickyFilters" className="nw-stickyfilterblock">
              <h1 className="nw-stickyfilterblock-filterheadings">
                FILTER BY:
              </h1>
              <ul className="nw-stickyfilterblock-list">
                {filterBy
                  .slice(2, 6)
                  .map(eachfilterBy => (
                    <FilterContainer
                      key={eachfilterBy.displayName}
                      eachfilterBy={eachfilterBy}
                    />
                  ))}
              </ul>
            </form>
          </GridColumn>
        </GridRow>
      </GridContainer>
    );
    if ((global && global.isServer) || !isDesktop) {
      return null;
    }
    return ReactDOM.createPortal(
      RenderComponent,
      document.querySelector(".nw-header-stickyfilter"),
    );
  }
}

StickyFilterBlock.wrappedComponent.defaultProps = {
  ProductStore: PropTypes.shape({}),
};

StickyFilterBlock.wrappedComponent.propTypes = {
  ProductStore: PropTypes.shape({
    ProductData: PropTypes.object,
  }),
};

export default StickyFilterBlock;



// WEBPACK FOOTER //
// ./src/component/ProductFilters/StickyFilterBlock/index.js